export default "__VITE_ASSET__C6186idN__"